import { IEmailNotificationsSetting } from "../../interfaces/memberInteriorSettings/iEmailNotificationsSetting";

export class EmailNotificationsSetting implements IEmailNotificationsSetting {
	isActive: boolean;
	notification: string;
	id: number;

	constructor(emailNotificationsSetting: IEmailNotificationsSetting = {} as IEmailNotificationsSetting) {
		this.isActive = !!emailNotificationsSetting.isActive;
		this.notification = emailNotificationsSetting.notification;
		this.id = emailNotificationsSetting.id;
	}
}



// WEBPACK FOOTER //
// ./static-content/private/javascripts/models/classes/memberInteriorSettings/emailNotificationsSetting.ts